/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object, string } from 'prop-types';
import Media from 'react-media';
import SubCollectionSelector from './Partials/SubCollectionSelector';
import uniqueId from '../../../helpers/contentstack/uniqueId';

const  SubCollection = ({ data, ssrDeviceType }) => {
    if (!data || !data.reference || !data.reference.length) return null;
    const {
        heading, subcollection_brand: subcollectionBrand, presentation_type: presentationType, pim_code: collectionId, linking, unique_selector, mobile_presentation_type: mobilePresentationType,
    } = data.reference[0];

    const { dataUniqueId } = uniqueId(unique_selector);
    const devicePageSize = ssrDeviceType === 'desktop' ? data.reference[0]?.page_size : data.reference[0].page_size_mobile;
    const collectionLink = linking?.link?.href || '';
    // presentationType is for Desktop
    // mobilePresentationType is for Mobile
    if (presentationType === 'Standard' || presentationType === 'Carousel') {
        return (
            <div className="subcollection_block" data-uniqueid={dataUniqueId}>
                <Media query="(max-width: 599px)">
                    {(matches) => (
                        matches ? (
                            <SubCollectionSelector
                                dataObj={{
                                    trackData: linking, heading, subcollectionBrand, collectionLink, collectionId, devicePageSize, presentationType: mobilePresentationType || 'Standard',
                                }}
                                ssrDeviceType={ssrDeviceType}
                            />
                        ) : (
                            <SubCollectionSelector
                                dataObj={{
                                    trackData: linking, heading, subcollectionBrand, collectionLink, presentationType, collectionId, devicePageSize,
                                }}
                                ssrDeviceType={ssrDeviceType}
                            />
                        )
                    )}
                </Media>

            </div>
        );
    }
    return null;
};

SubCollection.propTypes = {
    data: object.isRequired,
    ssrDeviceType: string.isRequired,
};

export default SubCollection;
